module.exports = __webpack_public_path__ + "img/202412100303.d5c76f37.png";